<template>
  <div :class="elementClass">
    <div class="scroll-area" ref="scrollArea">
      <slot></slot>
      <div class="focus-line" ref="focusLine"></div>
    </div>
  </div>
</template>

<script>
import { tabBarClass } from "../prefix";
export default {
  props: {
    value: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      internalValue: this.value,
      previousChild: null,
    };
  },
  computed: {
    elementClass() {
      return tabBarClass;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.focusLine.style.width = this.$children[0].$el.clientWidth + "px";
      this.$children[0].active = true;
      this.previousChild = this.$children[0];
    });
  },
  methods: {
    childClick(child) {
      let width = 0;
      if (this.previousChild) {
        this.previousChild.active = false;
      }
      child.active = true;
      this.previousChild = child;
      this.$children.forEach((item, index) => {
        if (item._uid === child._uid) {
          this.$refs.focusLine.style.width = item.$el.clientWidth + "px";
          this.$refs.focusLine.style.transform = `translateX(${width}px)`;
          if (this.$el.clientWidth * 0.8 < width + item.$el.clientWidth && this.internalValue < index) {
            this.$refs.scrollArea.scrollLeft = this.$refs.scrollArea.scrollLeft + item.$el.clientWidth;
          }
          if (this.$el.clientWidth * 0.2 < width + item.$el.clientWidth && this.internalValue > index) {
            this.$refs.scrollArea.scrollLeft = this.$refs.scrollArea.scrollLeft - item.$el.clientWidth;
          }
          this.internalValue = index;
          this.$emit("input", index);
        }
        width += item.$el.clientWidth;
      });
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-tab-bar";

#{$element} {
  width: 100%;
  overflow: hidden;
  height: 48px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  .scroll-area {
    overflow-x: scroll;
    overflow-y: hidden;
    min-height: 48px;
    display: flex;
    flex: 1 0 auto;
    scroll-behavior: smooth;
    .focus-line {
      width: 100%;
      height: 2px;
      background: $theme-primary;
      position: absolute;
      bottom: 0;
      left: 0;
      will-change: width;
      @include transition(all 0.2s $animation-deceleration-curve-timing-function);
    }
  }
}
</style>
